<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('payroll')">
            <app-default-button
                v-if="$can('view_beneficiaries')"
                :title="$t('beneficiary_badge')"
                :url="'/payroll/beneficiary-badges'"
                btn-class="btn btn-primary mr-2"
            />
            <app-default-button
                :title="$t('payrun')"
                v-if="$can('send_bulk_payslip')"
                btn-class="btn btn-primary mr-2"
                @click="openModal()"
            />
            <app-default-button
                :title="$t('import')"
                :btnClass="'btn btn-danger'"
                v-if="$can('send_bulk_payslip')"
                @click="isModalImport = true"
            />
        </app-page-top-section>

        <app-table
            id="salary-sheet-table"
            :options="options"
            @action="triggerActions"
        />

        <app-salary-sheet-edit
            v-if="isModalEdit"
            v-model="isModalEdit"
            :selected-url="selectedUrl"
            :rowData="rowData"
            @close="isModalEdit = false"
        />

        <app-salary-sheet-view
            v-if="isModalView"
            v-model="isModalView"
            :rowData="rowData"
            @close="isModalView = false"
        />

        <app-salary-sheet-create
            v-if="isModalCreate"
            v-model="isModalCreate"
            :selected-url="selectedUrl"
            @close="isModalCreate = false"
        />

        <app-salary-receipt-create
            v-if="isModalReceipt"
            v-model="isModalReceipt"
            :selected-url="selectedUrl"
            :rowData="rowData"
            @close="isModalReceipt = false"
        />

        <app-salary-payment-modal
            v-if="isModalPayment"
            v-model="isModalPayment"
            :rowData="rowData"
            @close="isModalPayment = false"
        />

        <app-salary-sheet-import
            v-if="isModalImport"
            v-model="isModalImport"
            :selected-url="selectedUrl"
            @close="isModalImport = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('salary-sheet-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import SalarySheetMixin from "../../Mixins/SalarySheetMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "SalarySheet",
    mixins: [HelperMixin, SalarySheetMixin, TENANT_BASE_URL],
    data() {
        return {
            isModalImport : false,
            isModalEdit   : false,
            isModalCreate : false,
            isModalView   : false,
            isModalReceipt: false,
            isModalPayment: false,
            rowData       : {},
            selectedUrl   : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            this.selectedUrl = `${TENANT_BASE_URL}app/salary-sheet/${row.id}`;

            if (action.actionName === 'view') {
                this.rowData     = row;
                this.isModalView = true;
            } else if (action.title === this.$t('edit')) {
                this.isModalEdit = true;
                this.rowData     = row;
            } else if (action.title === this.$t('confirm')) {
                if (!this.isAuthorizedToConfirm(row)) {
                    this.$toastr.e(this.$t('unauthorized'));
                    return;
                }

                this.isModalReceipt = true;
                this.rowData        = row;
            } else if (action.actionName === 'payment') {
                this.rowData        = row;
                this.isModalPayment = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        isAuthorizedToConfirm(row) {
            const userId = window.user?.id;
            if (!userId) {
                return false;
            }

            if (this.$isAdmin && this.$isAdmin()) {
                return true;
            }

            return [row.created_by, row.employee_id, row.receipt?.created_by].includes(userId);
        },
        openModal() {
            this.isModalCreate = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

<style scoped>
::v-deep .employee-id-column {
    white-space: nowrap;
}
</style>
